import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types';
import {
    Button, Grid, withStyles, TextField, IconButton, InputAdornment, Typography, Link, Box
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Field, reduxForm, change } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { styles } from '../../styles';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { VisibilityOff, Visibility, Edit } from '@material-ui/icons';
import DateFnsUtils from '@date-io/date-fns';
import * as actions from '../../../store/actions/members';
import Moment from 'moment';
import { subHeaderLabel, textLabelBold, textLabel, text } from "../meCommon";
import IcareLogo from "../../../assets/images/icare_logo_transparent.png";
import moment from 'moment';
import Recaptcha from "react-recaptcha";
import AlertDialog from '../../common/AlertDialog';
import URLDialog from '../../common/URLDialog';
import { TermsAndConditions, PrivacyPolicy } from './../../Constants';
import { InfoIcon } from "../../icons"

Moment.locale('en');
const validate = values => {
    const errors = {};
    const required = [];
    required.forEach((field, index) => {
        if (!values[field]) {
            errors[field] = 'Required';
        }
    });
    return errors;
};

const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const pwdRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
const phoneRegex = /^[\s.-]?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

class Register extends Component {

    constructor(props){
        super(props);
        this.state = {
            userId : '', firstName : '', lastName : '', email : '', phone : '', 
            dateOfBirth : null,
            password : '', confirmPassword : '', memberId: '', isGaurdianInfoRequired: false,
            caseHeadFirstName: '', caseHeadLastName: '', caseHeadId: '',
            error: {userId: '', firstName: '', lastName: '', email: '', phone: '', dateOfBirth: '',
            password: '', confirmPassword: '', memberId: '', caseHeadFirstName: '', caseHeadLastName: '', caseHeadId: ''},
            show: { password: false, confirmPassword: false },
            isPwdLength: true, isOneUpperLetter: true, isOneLowerLetter: true, isOneNumber: true, isOneSpecial: true,
            isMemberInfo: true,
            isCaptchaVerified: false,
            emailVerificationCode: 0,
            showEmailVerification: false,
            isEmailVerified: false,
            showVerificationControls: false,
            disableEmailEdit: false,
            showAlert: false
        }
    }


    handleChange = (event) => {
        if(this.props.errorMessage) {
            this.props.dispatch(actions.resetErrorMsg);
        }
        
        let value = event.target.value;
        let name = event.target.name;
        this.setState({[name]: value}, () => {
        switch(name){
            case "email":
                if (emailRegex.test(value)) {
                    this.setState({ error: {...this.state.error, email: ''}});
                } else {
                    this.setState({ error: {...this.state.error, email: 'Please enter a valid email.'}});
                }
                break;
            case "password":
                if (value.length < 8) {
                    this.setState({ isPwdLength: true});
                } else {
                    this.setState({ isPwdLength: false});
                }
                if (value.search(/[a-z]/) === -1) {
                    this.setState({ isOneLowerLetter: true});
                } else {
                    this.setState({ isOneLowerLetter: false});
                }
                if (value.search(/[A-Z]/) === -1) {
                    this.setState({ isOneUpperLetter: true});
                } else {
                    this.setState({ isOneUpperLetter: false});
                }
                if (value.search(/[0-9]/) === -1) {
                    this.setState({ isOneNumber: true});
                } else {
                    this.setState({ isOneNumber: false});
                }
                if (value.search(/[!@#$%^&*]/) === -1) {
                    this.setState({ isOneSpecial: true});
                } else {
                    this.setState({ isOneSpecial: false});
                }
                if (pwdRegex.test(value)) {
                    this.setState({ error: {...this.state.error, password: ''}});
                } else {
                    this.setState({ error: {...this.state.error, password: 'Please use the below in your password:'}});
                }
                if(this.state.confirmPassword !== "" && (this.state.password !== this.state.confirmPassword)) {
                    this.setState({ error: {...this.state.error, confirmPassword: 'Confirm password should match password'}});
                } else {
                    this.setState({ error: {...this.state.error, confirmPassword: ''}});
                }
                break;
            case "confirmPassword":
                if (this.state.password === this.state.confirmPassword) {
                    this.setState({ error: {...this.state.error, confirmPassword: ''}});
                } else {
                    this.setState({ error: {...this.state.error, confirmPassword: 'Confirm password should match password'}});
                }
                break;
            case "phone":
                if (phoneRegex.test(value)) {
                    this.setState({ error: {...this.state.error, phone: ''}});
                } else {
                    this.setState({ error: {...this.state.error, phone: 'Please enter correct phone number'}});
                }
                break;
            default: 
        }    
        });
    };

    enableSubmit = () => {
        const { userId, firstName, lastName, email, dateOfBirth, password, confirmPassword, memberId, isGaurdianInfoRequired,
        caseHeadFirstName, caseHeadLastName, caseHeadId} = this.state;
        if (this.props.errorMessage) {
           window.scrollTo(0, 0);
        }
        if(userId && firstName && dateOfBirth && lastName && password && confirmPassword && memberId && !isGaurdianInfoRequired && !this.props.loading) {
            return false;
        } else if (isGaurdianInfoRequired && caseHeadId && caseHeadFirstName && caseHeadLastName && userId && firstName && dateOfBirth && lastName && password && confirmPassword && memberId ) {
            return false;
        }
        return true;
    }

    updateProfile = () => {
        let memberObj = {};
        memberObj.firstName = this.state.firstName;
        memberObj.lastName = this.state.lastName;
        memberObj.memberId = this.state.memberId;
        memberObj.dateOfBirth = moment(this.state.dateOfBirth).format("YYYY-MM-DD");
        memberObj.hasCaseHead = this.props.hasCaseHead;
        if (this.props.hasCaseHead) {
            memberObj.caseHeadFirstName = this.state.caseHeadFirstName;
            memberObj.caseHeadLastName = this.state.caseHeadLastName;
            memberObj.caseHeadId = this.state.caseHeadId;
        }
        memberObj.userId = this.state.userId;
        memberObj.password = this.state.password;
        memberObj.email = this.state.email;
        memberObj.phone = this.state.phone;
        this.props.dispatch(actions.registerMember(memberObj, () => {
            this.setState({ showAlert: true });
        }));
        
    }
    getVerificationCode = () => {
        const { userId, email, memberId } = this.state;
        let params= {};
        params.userId= userId;
        params.email = email;
        params.memberId = memberId;
        this.props.dispatch(actions.getMemberVerificationCode(params, () => {
            this.props.history.push('/verifyMember');
            }));
    }

    renderTextField = (props) => {
        const {input, meta, label, isIcon, isDisabled, type, handleShow, error, required, multiline, ...custom} = props;
        return (
            <TextField
                name={input.name}
                id={input.name}
                label={label}
                error={(required && meta.touched && meta.pristine) || error}
                helperText={required && meta.touched && ((meta.pristine && <span className="text-danger">{label} is Required</span>)
                || (error && <span className="text-danger">{error}</span>)
                || (meta.warning && <span>{meta.warning}</span>))}
                margin="normal"
                variant="outlined" 
                fullWidth={true} 
                disabled={isDisabled}            
                {...input}
                {...custom}
                style={{backgroundColor: 'white'}}
                required={required}
                type={ type ? type : 'text' }  
                InputProps={{
                    endAdornment: (
                        <InputAdornment position='end'>
                        {isIcon && 
                        <IconButton onClick={handleShow}>
                            {type === 'text' ? 
                            <Visibility /> : 
                            <VisibilityOff />
                            }
                           
                        </IconButton>
                        }
                        </InputAdornment>
                    ),
                    startAdornment: <InputAdornment position="start">{label === "Mobile Phone" ? "+1" : ""}</InputAdornment>,
                  }}
            />
        );
    }    

    renderField = (name, label, value, required, error, password, isIcon, handleShow, isDisabled) => {
        return(
            <Field
                name={name} component={this.renderTextField} label={label} required={required}
                error={error} type={password} onChange={this.handleChange} isIcon={isIcon} handleShow={handleShow}
                isDisabled={isDisabled}
            />
        )
    }
    handleShow = (name) => {
        const { password, confirmPassword } = this.state.show;
        switch(name) {
            case 'password':
                this.setState({ show: {...this.state.show, password: !password }});
                break;
            case 'confirmPassword':
                this.setState({ show: {...this.state.show, confirmPassword: !confirmPassword }});
                break;
            default:
                //
        }
    }
    renderButton = (label, handler, disabled, variant, color) => {
        return (
            <Button variant={variant || "contained"} color={color || "primary"} onClick={handler} disabled={disabled}>
                {label}
                {label === "Register" && <span style={{ paddingLeft: '10px' }}>
                    {this.props.loading && (
                        <CircularProgress size={16} thickness={2} color='inherit' />
                    )}
                </span>}
            </Button>
        );
    }

    dateHandler = (name, value) => {
        this.setState({ [name]: value });
    }
    renderDate = (name, label, value) => {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    autoOk
                    variant="inline"
                    inputVariant="outlined"
                    label={label}
                    format="MM/dd/yyyy"
                    placeholder="MM/DD/YYYY"
                    value={value}
                    InputAdornmentProps={{ position: "end" }}
                    onChange={date => this.dateHandler(name, date)}
                    disableFuture={true}
                    clearable={"true"}
                    openTo="year"
                    views={["year", "month", "date"]}
                    fullWidth
                    required
                />
                <Typography variant="caption" color="error">
                    {/* {errors} */}
                </Typography>
            </MuiPickersUtilsProvider>
        );
    }
    resetProfile = () => {
        if(this.props.errorMessage) {
            this.props.dispatch(actions.resetErrorMsg);
        }
    }

    renderProgress = () => {
        const { loading } = this.props;
        if (loading) {
            return (
                <CircularProgress
                    size={70}
                    color={"secondary"}
                    style={{position: 'absolute', jusitfyContent: 'center', top: 0, left: 0, bottom: 0, right: 0, margin: 'auto'}}
                />
            );
        } else {
            return null;
        }
    }
    handleNext() {
        let memberObj = {};
        memberObj.firstName = this.state.firstName;
        memberObj.lastName = this.state.lastName;
        memberObj.memberId = this.state.memberId;
        memberObj.dateOfBirth = moment(this.state.dateOfBirth).format("YYYY-MM-DD");
        this.props.dispatch(actions.validateMember(memberObj, () => {
            this.setState({ isMemberInfo: false, showEmailVerification: true });
            if(this.props.errorMessage) {
                this.props.dispatch(actions.resetErrorMsg);
            }
         }));
         this.captcha.reset();
        //  grecaptcha.reset();
    }
    handleBack() {
        this.props.dispatch(change('registerForm', 'password'));
        this.props.dispatch(change('registerForm', 'confirmPassword'));
        this.setState({ isMemberInfo: true, password: '', confirmPassword: '', showEmailVerification: false, isCaptchaVerified: false});
    }
    onCaptchaChange = (response) => {
        if(response){
            this.setState({ isCaptchaVerified: true });
        }
    }
    recaptchaLoaded(){
        console.log("Captcha loaded")
    }
    memberInformation = () => {
        const { firstName, lastName, dateOfBirth, memberId, isCaptchaVerified } = this.state;
        const { classes } = this.props;
        return(
            <Grid container spacing={2} >
                <Grid item key={1} xs={12} sm={12} md={12} lg={12}>
                    <div className={classes.flexRowStart}>
                        <InfoIcon /><Typography variant="body2" style={{ paddingLeft: '10px'}}>Access will be given up to 5 years after terminating with iCare.</Typography>
                    </div>
                </Grid>
                <Grid item key={2} xs={12} sm={12} md={12} lg={12}>
                    {subHeaderLabel("Member Information")}
                </Grid>
                <Grid item key={3} xs={12} sm={6} md={6} lg={6}>
                    {this.renderField('firstName', 'First Name', firstName, true)}
                </Grid>
                <Grid item key={4} xs={12} sm={6} md={6} lg={6}>
                    {this.renderField('lastName', 'Last Name', lastName, true)}
                </Grid>
                <Grid item key={5} xs={12} sm={6} md={6} lg={6}>
                    {this.renderField('memberId', 'Member ID', memberId, true, this.state.error.memberId)}
                </Grid>
                <Grid item key={6} xs={12} sm={6} md={6} lg={6} style={{ paddingTop: "25px", paddingLeft: "10px" }}>
                    {this.renderDate('dateOfBirth', 'Date of Birth', dateOfBirth)}
                </Grid>
 
                <Grid container alignItems='center' justify='center' >
                    <Recaptcha
                        sitekey="6LcGthMbAAAAADHLKEEDC3cPNUW0NzwDEDjh7Rx4"
                        render="explicit"
                        verifyCallback={this.onCaptchaChange}
                        onloadCallback={this.recaptchaLoaded}
                        ref={e => (this.captcha = e)}
                    />
                </Grid>
                <Grid container alignItems='flex-end' justify='flex-end'  style={{ paddingTop: "20px"}}>
                    {this.renderButton('Next', () => this.handleNext(), !(firstName && lastName && dateOfBirth && memberId && !this.props.loading && isCaptchaVerified))}
                </Grid>
            </Grid>
        )
    }
    
    gaurdianInformation = () => {
        const { caseHeadFirstName, caseHeadLastName, caseHeadId } = this.state;

        return (
                    <Grid container spacing={2}>
                        <Grid item key={7} xs={12} sm={12} md={12} lg={12} style={{ marginTop: "20px" }}>
                            {subHeaderLabel("Please enter parent/guardian information")}
                        </Grid>
                        <Grid item key={100} xs={12} sm={6} md={6} lg={6} >
                            {this.renderField('caseHeadFirstName', 'First Name', caseHeadFirstName, true)}
                        </Grid>
                        <Grid item key={101} xs={12} sm={6} md={6} lg={6} >
                            {this.renderField('caseHeadLastName', 'Last Name', caseHeadLastName, true)}
                        </Grid>
                        <Grid item key={102} xs={12} sm={6} md={6} lg={6} >
                            {this.renderField('caseHeadId', 'Parent/Guardian ID', caseHeadId, true)}
                        </Grid>
                    </Grid>
                    )
    }
    sendEmailVerificationCode = () => {
        let params = {};
        params.email = this.state.email;
        this.props.dispatch(actions.getEmailVerificationCode(params, () => {
            this.setState({ showVerificationControls: true, disableEmailEdit: true })
        }));
    }
    verifyEmail = () => {
        let params = {};
        params.email = this.state.email;
        params.verificationCode = this.state.emailVerificationCode;
        this.props.dispatch(actions.verifyEmail(params, () => {
            this.setState({ isEmailVerified: true })
        }));
    }
    handleEditEmail = () => {
        this.setState({ disableEmailEdit: false });
    }
    emailVerification = () => {
        const { email, emailVerificationCode, disableEmailEdit } = this.state;
        const { handleSubmit, loading } = this.props;
        return (
                <Fragment>
                    <Grid container spacing={2}>
                        <Grid item key={7} xs={12} sm={12} md={12} lg={12} style={{ marginTop: "20px" }}>
                            {subHeaderLabel("Email Verification")}
                        </Grid>
                        <Grid item key={8} xs={12} sm={12} md={6} lg={6}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                                {this.renderField('email', 'Email', email, true, this.state.error.email, "email", false, null, disableEmailEdit )}
                            </div>
                        </Grid>
                        <Grid item key={9} xs={12} sm={12} md={6} lg={6} style={{ alignItems: "center", display: "flex" }}>
                            {disableEmailEdit && this.renderButton('Edit', () => this.handleEditEmail(), loading, "text", "secondary")}
                        </Grid>
                        {/* name, label, value, required, error, password, isIcon, handleShow, isDisabled */}
                        <Grid item key={10} xs={12} sm={12} md={6} lg={6}>
                            {disableEmailEdit && 
                            this.renderField('emailVerificationCode', 'Email Verification Code', emailVerificationCode, true, "", "number")}
                        </Grid>
                        <Grid item key={11} xs={12} sm={12} md={6} lg={6}></Grid>
                    </Grid>
                    <Grid item key={12} xs={12} sm={12} md={12} lg={12} >
                        <Grid container spacing={1} alignItems="center" justify="space-between" style={{ marginTop: "40px" }} >
                            {this.renderButton('Back', () => this.handleBack(), loading, "text", "secondary")}
                            {!disableEmailEdit && this.renderButton('Send verification Code', handleSubmit(this.sendEmailVerificationCode), !email || this.state.error.email || loading)}
                            {disableEmailEdit && this.renderButton('Verify', handleSubmit(this.verifyEmail), emailVerificationCode === 0 || loading)}
                        </Grid>
                    </Grid>
                    </Fragment>
                    )
    }
    userInformation = () => {
        const { userId, email, phone, show, password, confirmPassword, disableEmailEdit,
            isPwdLength, isOneLowerLetter, isOneUpperLetter, isOneNumber, isOneSpecial} = this.state;
        const { hasCaseHead } = this.props;
        return (
                <Fragment>
                    { hasCaseHead && this.gaurdianInformation()}
                    <Grid container spacing={2}>
                        <Grid item key={7} xs={12} sm={12} md={12} lg={12} style={{ marginTop: "20px" }}>
                            {subHeaderLabel("User Information")}
                        </Grid>
                        <Grid item key={8} xs={12} sm={6} md={6} lg={6} >
                            {this.renderField('userId', 'User ID', userId, true, this.state.error.userId)}
                        </Grid>
                        <Grid item key={9} xs={12} sm={6} md={6} lg={6}></Grid>

                        <Grid item key={10} xs={12} sm={6} md={6} lg={6} >
                            {this.renderField('password', 'Password', password, true, this.state.error.password, show.password ? "text" : "password", true, () => this.handleShow('password'))}
                            {isPwdLength && text("body2", "Minimum 8 characters", { color: "#49afde"})}
                            {isOneUpperLetter && text("body2", "One uppercase letter", { color: "#49afde"})}
                            {isOneLowerLetter && text("body2", "One lowercase letter", { color: "#49afde"})}
                            {isOneNumber && text("body2", "One number", { color: "#49afde"})}
                            {isOneSpecial && text("body2", "One special character(Ex: !, @, #, $, %, ^, &, *)", { color: "#49afde"})}
                            
                        </Grid>
                        <Grid item key={11} xs={12} sm={6} md={6} lg={6}>
                            {this.renderField('confirmPassword', 'Confirm Password', confirmPassword, true, this.state.error.confirmPassword, show.confirmPassword ? "text" : "password", true, () => this.handleShow('confirmPassword'))}
                        </Grid>

                        <Grid item key={12} xs={12} sm={12} md={12} lg={12} style={{ marginTop: "20px" }}>
                            {subHeaderLabel("Email/Phone")}
                        </Grid>

                        <Grid item key={13} xs={12} sm={6} md={6} lg={6} >
                            {/* {this.renderField('email', 'Email', email, true, this.state.error.email)} */}
                            {this.renderField('email', 'Email', email, true, this.state.error.email, "text", false, null, disableEmailEdit )}
                        </Grid>
                        <Grid item key={14} xs={12} sm={6} md={6} lg={6} >
                            {this.renderField('phone', 'Mobile Phone', phone, false, this.state.error.phone)}
                        </Grid>
                    </Grid>
                    {this.formActions()}
                    </Fragment>
                    )
    }
    closeAlert = () => {
        if(this.state.showAlert){
            this.setState({ showAlert: false });
        }
        window.location = "https://www.icarehealthplan.org/Utility-Navigation/interoperability-faqs.htm";
    }
    formActions = () => {
        const { handleSubmit, loading } = this.props;
        return(
            <Grid item key={19} xs={12} sm={12} md={12} lg={12} >
                <Grid container spacing={1} alignItems="center" justify="space-between" style={{ marginTop: "40px" }} >
                    {this.renderButton('Back', () => this.handleBack(), loading, "text", "secondary")}
                    {this.renderButton('Register', handleSubmit(this.updateProfile), this.enableSubmit())}
                </Grid>
            </Grid>
        )
    }
    render() {
        const { classes, errorMessage } = this.props;
        const { showEmailVerification, isEmailVerified } = this.state;
        const alreadyRegistered = errorMessage && errorMessage.includes(" already registered");
        return(
            <Grid container spacing={1} alignItems='center' justify='center'>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ height: "45px", backgroundColor: "#008675"}}></Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "0 45px", height: "110px"}}>
                    <Grid container direction="row" spacing={0}>
                        <Grid item key={1} xs={4} sm={4} md={4} lg={4}>
                            <Grid container direction="row" justify="center" alignItems="center">
                                <span className={classes.logo}>
                                    <img src={IcareLogo} alt="Icare" height="135px"/>
                                </span>
                            </Grid>
                        </Grid>
                        <Grid item key={2} xs={8} sm={8} md={8} lg={8} >
                            <Grid container direction="row" justify="flex-start" alignItems="center" style={{height: "135px", paddingLeft: "30px"}}>
                                {textLabelBold("h4", "Member Registration")}
                            </Grid>
                            
                           
                        </Grid>

                    </Grid>
                    
                </Grid>

                <Grid item xs={10} sm={10} md={9} lg={8} style={{ padding: "25px", marginTop: "40px"}}>
                    {errorMessage &&
                        <Grid container spacing={0} style={{ padding: "5px", border: "1px solid rgb(227, 20, 20, .23)", marginBottom: "20px" }}>
                            
                            <Grid item key={37} xs={12} sm={12} md={12} lg={12} >
                                <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                                    <Typography variant="body1">Please fix the below error to move forward with registration: </Typography>
                                    <Typography variant="body1" color="error">{errorMessage} </Typography>
                                    {alreadyRegistered && <Typography variant="body1"  component={'span'} >To retrieve User Id/Password
                                        <Box fontWeight="fontWeightRegular" display="inline">
                                            <Link href="#" onClick={()=>{this.props.history.push('/forgot')}}> Click here</Link>
                                        </Box> 
                                    </Typography>}
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    { this.state.isMemberInfo && this.memberInformation()}
                    { showEmailVerification && !isEmailVerified && this.emailVerification()}
                    { !this.state.isMemberInfo && isEmailVerified && this.userInformation()}
                    { this.state.showAlert && <AlertDialog open={true} message="Member registration is complete" close={this.closeAlert}/>}
                    <Grid item key={38} xs={12} sm={12} md={12} lg={12}>{this.renderProgress()}</Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} >
                    <Grid spacing={4} direction="row" container justify="center" alignItems="center" style={{ padding: "20px"}}>
                        <URLDialog linkName= "Terms & Conditions" urlLink={TermsAndConditions} />
                        <span style={{ width: "40px"}}></span>
                        <URLDialog linkName= "Privacy Policy" urlLink={PrivacyPolicy}/>
                    </Grid>
                </Grid>
                
            </Grid>
        )
    }
}

Register.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

const mapStateToprops = (state) => {
    return {
        loading: state.members && state.members.loading,
        errorMessage: state.members && state.members.errorMessage,
        hasCaseHead: state.members && state.members.hasCaseHead,
        initialValues: {
            
        }
    };
};

Register = reduxForm({ 
    form: 'registerForm' ,
    enableReinitialize: true,
    validate,
    fields: [
        'userId', 'firstName', 'lastName', 'email', 'phone', 
        'country', 'zip', 'state', 'city', 'gender', 'dateOfBirth', 
        'password', 'confirmPassword' 
    ]
})(Register);

export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToprops, mapDispatchToProps)
)(Register); 